import(/* webpackMode: "eager" */ "/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/tour-detail/index.tsx");
